export type FrameworkNode = {
  framework: "ISM" | "ISPS" | "MLC" | "STATUTORY";
  ref: string;
  label: string;
  restricted?: boolean;
};

export const ISM_ELEMENTS: FrameworkNode[] = [
  { framework: "ISM", ref: "ISM-1", label: "1. General and Scope" },
  { framework: "ISM", ref: "ISM-2", label: "2. Safety & Environmental Protection Policy" },
  { framework: "ISM", ref: "ISM-3", label: "3. Company Responsibility & Authority" },
  { framework: "ISM", ref: "ISM-4", label: "4. Designated Person Ashore (DPA)" },
  { framework: "ISM", ref: "ISM-5", label: "5. Master's Responsibility & Authority" },
  { framework: "ISM", ref: "ISM-6", label: "6. Resources & Personnel" },
  { framework: "ISM", ref: "ISM-7", label: "7. Shipboard Operations" },
  { framework: "ISM", ref: "ISM-8", label: "8. Emergency Preparedness" },
  { framework: "ISM", ref: "ISM-9", label: "9. Non-Conformities, Accidents, Near-Misses" },
  { framework: "ISM", ref: "ISM-10", label: "10. Maintenance of Ship & Equipment" },
  { framework: "ISM", ref: "ISM-11", label: "11. Documentation" },
  { framework: "ISM", ref: "ISM-12", label: "12. Verification, Review & Evaluation" },
  { framework: "ISM", ref: "ISM-CERT-DOC", label: "Certification — Document of Compliance" },
  { framework: "ISM", ref: "ISM-CERT-SMC", label: "Certification — Safety Management Certificate" },
];

export const ISPS_ITEMS: FrameworkNode[] = [
  { framework: "ISPS", ref: "ISPS-CSO", label: "Company Security Officer (CSO)" },
  { framework: "ISPS", ref: "ISPS-SSO", label: "Ship Security Officer (SSO)" },
  { framework: "ISPS", ref: "ISPS-SSA", label: "Ship Security Assessment (SSA)" },
  { framework: "ISPS", ref: "ISPS-SSP", label: "Ship Security Plan (SSP)", restricted: true },
  { framework: "ISPS", ref: "ISPS-DRILLS", label: "Security Drills & Exercises" },
  { framework: "ISPS", ref: "ISPS-DOS", label: "Declaration of Security (DoS)" },
  { framework: "ISPS", ref: "ISPS-ISSC", label: "International Ship Security Certificate (ISSC)" },
  { framework: "ISPS", ref: "ISPS-TRAINING", label: "Security Training & Awareness" },
];

export const MLC_AREAS: FrameworkNode[] = [
  { framework: "MLC", ref: "MLC-DMLC1", label: "DMLC Part I" },
  { framework: "MLC", ref: "MLC-DMLC2", label: "DMLC Part II" },
  { framework: "MLC", ref: "MLC-CERT", label: "Maritime Labour Certificate" },
  { framework: "MLC", ref: "MLC-1.1", label: "1.1 Minimum Age" },
  { framework: "MLC", ref: "MLC-1.2", label: "1.2 Medical Certification" },
  { framework: "MLC", ref: "MLC-1.3", label: "1.3 Qualifications of Seafarers" },
  { framework: "MLC", ref: "MLC-2.1", label: "2.1 Seafarers' Employment Agreements" },
  { framework: "MLC", ref: "MLC-2.2", label: "2.2 Recruitment & Placement" },
  { framework: "MLC", ref: "MLC-2.3", label: "2.3 Hours of Work & Rest" },
  { framework: "MLC", ref: "MLC-2.7", label: "2.7 Manning Levels" },
  { framework: "MLC", ref: "MLC-3.1", label: "3.1 Accommodation" },
  { framework: "MLC", ref: "MLC-3.2", label: "3.2 Recreational Facilities" },
  { framework: "MLC", ref: "MLC-3.3", label: "3.3 Food & Catering" },
  { framework: "MLC", ref: "MLC-4.1", label: "4.1 Health, Safety & Accident Prevention" },
  { framework: "MLC", ref: "MLC-4.2", label: "4.2 On-board Medical Care" },
  { framework: "MLC", ref: "MLC-4.3", label: "4.3 On-board Complaint Procedures" },
  { framework: "MLC", ref: "MLC-4.4", label: "4.4 Payment of Wages" },
  { framework: "MLC", ref: "MLC-5.1", label: "5.1 Financial Security — Repatriation" },
  { framework: "MLC", ref: "MLC-5.2", label: "5.2 Financial Security — Shipowner Liability" },
];

export const STATUTORY_ITEMS: FrameworkNode[] = [
  { framework: "STATUTORY", ref: "CORP-CHARTER", label: "Corporate — Charter Agreements" },
  { framework: "STATUTORY", ref: "CORP-INSURANCE", label: "Corporate — Insurance & Financial Security" },
  { framework: "STATUTORY", ref: "CORP-SANCTIONS", label: "Corporate — Sanctions Compliance" },
  { framework: "STATUTORY", ref: "CORP-ABC", label: "Corporate — Anti-Bribery & Corruption" },
];

export const FRAMEWORKS = {
  ISM: { label: "ISM Code — Safety Management", items: ISM_ELEMENTS },
  ISPS: { label: "ISPS Code — Security", items: ISPS_ITEMS },
  MLC: { label: "MLC 2006 — Maritime Labour", items: MLC_AREAS },
  STATUTORY: { label: "Statutory / Class", items: STATUTORY_ITEMS },
};
